import TeamAssignmentsPanelContainer from '../teamAssignmentsPanel/TeamAssignmentsPanelContainer'
import {isUGREnabled} from '../../../features/selectors'
import {
    getAssignedGroupIds,
    getAssignedUserIds,
    getTeamAssignmentType, getUserFML,
    getUserGroups,
    getUsers,
} from '../teamAssignmentsPanel/selectors'
import {connect} from '../../../redux/utils'
import {bindActionCreators} from 'redux'
import {isPanelOpened} from './selectors'
import {cancelUserCreation, changeTeamAssignments} from '../createPanel/actions'
import {closeTeamAssignmentsPanel} from './actions'
import {isShown as isUserCreatePanelOpened} from '../createPanel/selectors'

class CreateTeamAssignmentsPanel extends TeamAssignmentsPanelContainer {
    constructor(params) {
        super({
            showCopyButton: false,
            additionalClass: 'createTeamAssignmentsPanel',
            ...params
        })
    }
}

export default connect(
    state => ({
        isShown: isPanelOpened(state),
        userPanelOpenedBelow: isUserCreatePanelOpened(state),
        assignedUserIds: getAssignedUserIds(state),
        assignedGroupIds: getAssignedGroupIds(state),
        users: getUsers(state),
        userGroups: getUserGroups(state),
        isUGREnabled: isUGREnabled(state),
        teamAssignmentType: getTeamAssignmentType(state),
        userFML: getUserFML(state),
    }),
    dispatch => ({
        onPanelHide: bindActionCreators(closeTeamAssignmentsPanel, dispatch),
        onCloseButtonClick: bindActionCreators(cancelUserCreation, dispatch),
        changeTeamAssignments: bindActionCreators(changeTeamAssignments, dispatch),
    })
)(CreateTeamAssignmentsPanel)


// WEBPACK FOOTER //
// ./web/js/panels/user/createTeamAssignmentsPanel/CreateTeamAssignmentsPanel.js